import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { neuroTestData } from '../../services/api/neuroScreen';

const NeuroTestTable = () => {
    const params = useParams();
    const path = params["*"];
    const [testType, sessionId] = path.split("/");
    const [neuroTestDataState, setNeuroTestDataState] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (sessionId && testType) {
            fetchNeuroTestData(sessionId, testType);
        }
    }, [testType, sessionId]);

    const fetchNeuroTestData = async (sessionId, tableName) => {
        setLoading(true);
        try {
            const response = await neuroTestData(sessionId, tableName);
            setNeuroTestDataState(response?.data?.data);
        } catch (error) {
            console.error("Error fetching neuro test data:", error);
        } finally {
            setLoading(false);
        }
    };

    const renderTableHeaders = () => {
        const commonHeaders = [
            "Serial No",
            "StudyNumber",
            "Researcher/PI Id",
            "Participant Id",
            "SessionId"
        ];

        const specificHeaders = {
            FaceAware: [
                "Shown Name",
                "Selected Name",
                "Shown Profession",
                "Selected Profession",
                "Is Name Correct",
                "Is Profession Correct",
            ],
            TubeTest_Response: [
                "TestType",
                "TubeId",
                "TubeAnswer",
                "Is Answer Correct",
                "Average Response Time",
                "User Response"
            ]
        };

        const headers = [...commonHeaders, ...(specificHeaders[testType] || [])];

        return (
            <tr>
                {headers.map((header, index) => (
                    <th key={index}>{header}</th>
                ))}
            </tr>
        );
    };

    const renderTableRow = (row) => {
        const commonCells = [
            testType === 'FaceAware' ? row.FaceAwareId : row.Id,
            row.StudyNumber,
            row.UserId,
            row.PatientId,
            row.SessionId
        ];

        const specificCells = {
            FaceAware: [
                row.ShownName,
                row.SelectedNames,
                row.ShownProfession,
                row.SelectedProfession,
                row.IsNameCorrect ? 'Yes' : 'No',
                row.IsProfessionCorrect ? 'Yes' : 'No',
            ],
            TubeTest_Response: [
                row.TestType,
                row.TubeId,
                row.CorrectAnswer,
                row.IsAnswerCorrect ? 'Yes' : 'No',
                `${row.AverageResponseTime?.toFixed(2)}s`,
                row.SelectedAnswer
            ]
        };

        const cells = [...commonCells, ...(specificCells[testType] || [])];

        return (
            <tr key={testType === 'FaceAware' ? row.FaceAwareId : row.Id}>
                {cells.map((cell, index) => (
                    <td key={index}>{cell ?? '-'}</td>
                ))}
            </tr>
        );
    };

    return (
        <section class="page_section w-100 ps-lg-4 pe-lg-5">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center">
                        <div class="page_title d-flex align-items-center">
                            <a href="/neuroscreen/" >
                                <svg width="40" height="40" class="me-3" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="39" y="39" width="38" height="38" rx="19" transform="rotate(180 39 39)" stroke="#101A36" stroke-width="2"></rect>
                                    <path
                                        d="M24.9999 19L17.4099 19L20.7099 15.71C20.8982 15.5217 21.004 15.2663 21.004 15C21.004 14.7337 20.8982 14.4783 20.7099 14.29C20.5216 14.1017 20.2662 13.9959 19.9999 13.9959C19.7336 13.9959 19.4782 14.1017 19.2899 14.29L14.2899 19.29C14.1989 19.3851 14.1275 19.4973 14.0799 19.62C13.9799 19.8635 13.9799 20.1365 14.0799 20.38C14.1275 20.5028 14.1989 20.6149 14.2899 20.71L19.2899 25.71C19.3829 25.8037 19.4935 25.8781 19.6153 25.9289C19.7372 25.9797 19.8679 26.0058 19.9999 26.0058C20.1319 26.0058 20.2626 25.9797 20.3845 25.9289C20.5063 25.8781 20.6169 25.8037 20.7099 25.71C20.8036 25.617 20.878 25.5064 20.9288 25.3846C20.9796 25.2627 21.0057 25.132 21.0057 25C21.0057 24.868 20.9796 24.7373 20.9288 24.6154C20.878 24.4936 20.8036 24.383 20.7099 24.29L17.4099 21L24.9999 21C25.2651 21 25.5195 20.8946 25.707 20.7071C25.8945 20.5196 25.9999 20.2652 25.9999 20C25.9999 19.7348 25.8945 19.4804 25.707 19.2929C25.5195 19.1054 25.2651 19 24.9999 19Z"
                                        fill="#101A36"
                                    ></path>
                                </svg>
                               <span style={{pointerEvents:'none'}}> { testType === 'FaceAware'?"Glanceaware":testType}</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end gap-3 mt-lg-0 mt-md-4 mt-3">
                        {/* <div class="view_test_button d-flex align-items-center">
                            <a download="sensify.csv" target="_self" href="blob:https://analytics.sensifyaware.com/1deb8a75-2460-4835-9a87-1c33f4b3c263" style="display: none;">Download CSV</a>
                            <button class="btn btn-primary bg-white ms-lg-4 ms-md-4 ms-3">Export</button>
                        </div> */}
                        {/* <div class="view_test_button d-flex align-items-center"><button class="btn btn-primary bg-white">Apply Filters</button></div> */}
                    </div>
                </div>
                <div class="row mt-lg-5 mt-md-4 mt-4">
                    <div class="col-12">
                        <div class="test_table w-100 overflow-auto">
                            <table class="table m-0" id="tableToExport" role="table">
                                <thead>
                                    {renderTableHeaders()}
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={testType === 'FaceAware' ? 12 : 11} className="text-center">Loading...</td>
                                        </tr>
                                    ) : neuroTestDataState.length === 0 ? (
                                        <tr>
                                            <td colSpan={testType === 'FaceAware' ? 12 : 11} className="text-center">No Data Available</td>
                                        </tr>
                                    ) : (
                                        neuroTestDataState.map(row => renderTableRow(row))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NeuroTestTable;
